export const WifiMark = ({ className = "", color = "#FF3333", pulsing = true }) => {
    const p = pulsing;
    return (
        <svg
            viewBox="0 14 100 66"
            className={className}
            fill="none"
            aria-label="Wi-Fi symbol"
            role="img"
        >
            <path
                d="M 6 66 A 44 44 0 0 1 94 66"
                stroke={color}
                strokeWidth="9"
                strokeLinecap="round"
                className={p ? "wifi-arc-3" : ""}
            />
            <path
                d="M 20 66 A 30 30 0 0 1 80 66"
                stroke={color}
                strokeWidth="9"
                strokeLinecap="round"
                className={p ? "wifi-arc-2" : ""}
            />
            <path
                d="M 34 66 A 16 16 0 0 1 66 66"
                stroke={color}
                strokeWidth="9"
                strokeLinecap="round"
                className={p ? "wifi-arc-1" : ""}
            />
            <circle cx="50" cy="68" r="8" fill={color} className={p ? "wifi-dot" : ""} />
        </svg>
    );
};

export const BrandWord = ({ className = "", markClassName = "" }) => (
    <span className={`inline-flex items-baseline ${className}`} data-testid="brand-word">
        <WifiMark className={`h-[0.62em] w-auto self-center translate-y-[0.06em] ${markClassName}`} />
        <span>FFLINE</span>
    </span>
);
